var BlogDataTestIdEnum = /* @__PURE__ */ ((BlogDataTestIdEnum2) => {
  BlogDataTestIdEnum2["BLOG_POST_RELATED"] = "blog--post-related";
  BlogDataTestIdEnum2["BLOG_POST_RELATED_CARD"] = "blog--post-related-card";
  BlogDataTestIdEnum2["BLOG_POST_RELATED_CARD_TITLE"] = "blog--post-related-card-title";
  BlogDataTestIdEnum2["BLOG_POST_RELATED_CARD_LINK"] = "blog--post-related-card-link";
  BlogDataTestIdEnum2["BLOG_POST_RELATED_CARD_LINK_TEXT"] = "blog--post-related-card-link-text";
  BlogDataTestIdEnum2["BLOG_POST_RELATED_CARD_LINK_ICON"] = "blog--post-related-card-link-icon";
  BlogDataTestIdEnum2["BLOG_POST_RELATED_CONTAINER"] = "blog--post-related-container";
  BlogDataTestIdEnum2["BLOG_WARNING"] = "blog--warning";
  BlogDataTestIdEnum2["BLOG_SHARE_TO_SOCIAL"] = "blog--share-to-social";
  BlogDataTestIdEnum2["BLOG_POST_CONTENT_CONTAINER"] = "blog--post-content-container";
  BlogDataTestIdEnum2["BLOG_LIST_BY_THEME"] = "blog--list-by-theme";
  BlogDataTestIdEnum2["BLOG_SHARE_TO_SOCIAL_MOBILE"] = "main-div--share-to-social-mobile";
  BlogDataTestIdEnum2["BLOG_THEME_LINK"] = "theme-name--theme-list";
  BlogDataTestIdEnum2["BLOG_ALL_POSTS_LINK"] = "all-posts--theme-list";
  BlogDataTestIdEnum2["BLOG_CAMPAIGN_FORM"] = "campaign-form";
  BlogDataTestIdEnum2["BLOG_CAMPAIGN_TITLE"] = "title--campaign-form";
  BlogDataTestIdEnum2["BLOG_POST_TITLE"] = "-title--post-card";
  BlogDataTestIdEnum2["BLOG_POST_CONTENT"] = "-post--post-card";
  BlogDataTestIdEnum2["BLOG_POST_DATE"] = "-publist-date--post-card";
  BlogDataTestIdEnum2["BLOG_POST_LINK"] = "--blog-list-post";
  BlogDataTestIdEnum2["BLOG_THEME_SELECT"] = "blog-theme-select";
  BlogDataTestIdEnum2["NATIVE_SHARE_BUTTON"] = "native-share-button--share-to-social-mobile";
  BlogDataTestIdEnum2["TWITTER_SHARE"] = "twitter-share--share-to-social-mobile";
  BlogDataTestIdEnum2["FALLBACK_SHARE_OPTIONS"] = "fallback-share-options--share-to-social-mobile";
  BlogDataTestIdEnum2["FACEBOOK_SHARE"] = "facebook-share--share-to-social-mobile";
  BlogDataTestIdEnum2["LINKEDIN_SHARE"] = "linkedin-share--share-to-social-mobile";
  BlogDataTestIdEnum2["WHATSAPP_SHARE"] = "whatsapp-share--share-to-social-mobile";
  BlogDataTestIdEnum2["TELEGRAM_SHARE"] = "telegram-share--share-to-social-mobile";
  BlogDataTestIdEnum2["BLOG_POST_HEADER"] = "post-header";
  BlogDataTestIdEnum2["BLOG_POST_HEADER_TITLE"] = "title--post-header";
  BlogDataTestIdEnum2["BLOG_POST_HEADER_DATE"] = "publish-date--post-header";
  BlogDataTestIdEnum2["BLOG_POST_HEADER_THEME_PILL"] = "-theme-pill--post-header";
  BlogDataTestIdEnum2["BLOG_POST_CARD_THEME_PILL"] = "-theme-pill--post-card";
  BlogDataTestIdEnum2["BLOG_POST_REVIEWER"] = "post-reviewer";
  BlogDataTestIdEnum2["BLOG_POST_REVIEWER_INTERN"] = "intern-review--post-reviewer";
  BlogDataTestIdEnum2["BLOG_POST_REVIEWER_EXTERN"] = "extern-review--post-reviewer";
  BlogDataTestIdEnum2["BLOG_CAMPAIGN_TERMS_SECTION"] = "terms-section--campaign-form";
  return BlogDataTestIdEnum2;
})(BlogDataTestIdEnum || {});
export {
  BlogDataTestIdEnum
};
